export default {
  title01: "Tiempo actual",
  title02: "24 Horas",
  title03: "Ver la previsión del tiempo para 10 días",
  title04: "Índice de Calidad del Aire (ICA)",
  title05: "Ver toda la información",
  title06: "AMANECER Y ATARDECER",
  title07: "FASE DE LA LUNA",
  title08: "Próxima luna llena",
  title09: "Próxima luna nueva",
  title10: "DÍA",
  title11: "NOCHE",
  title12: "Amanecer",
  title13: "Atardecer",
  title14: "Salida de la luna",
  title15: "Puesta de la luna",
  title16: "Fuente",
  title17: "Inicio",
  title18: "Fin",
  title19: "Utilizar ubicación actual",
  title20: "Buscar ciudad",
  title21: "Sensación térmica",
  title22: "Sensación térmica a la sombra",
  title23: "Ahora",
  title24: "Hoy",
  title25: "Dom.",
  title26: "Lun.",
  title27: "Mar.",
  title28: "Mié.",
  title29: "Jue.",
  title30: "Vie.",
  title31: "Sáb.",
  title32: "Cargando...",
  title33: "Ahora",
  title34: "Por horas",
  title35: "Por días",
  title36: "Sol y luna",
  title37: "Calidad del aire",
  title38: "Contactar con: xlf550402@gmail.com",
  title39: "Acuerdo de privacidad",
  title40: "Copyright © comfortweather.com 2020 - 2026. Todos los derechos reservados",
  title41: "Datos proporcionados por",
  title42: "Temp. Máx.",
  title43: "Temp. Mín.",
  title44: "Aceptar",
  title45:
    "¡Gracias por usar ComfortWeather! Para proteger mejor sus derechos e intereses legales, lea atentamente la ",
  title46: "Política de Privacidad",
  title47: " antes de usarla.",
  title48: "",
  title49: "Contactar con: xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2026. Todos los derechos reservados",
  title51: "¡Gracias por usar 24hweather! Para proteger mejor sus derechos e intereses legales, lea atentamente la ",
  title52: "Su ubicación ha cambiado. ¿Quieres actualizarla?",
  title53: "Confirmar",
  title54: "Cancelar",
  title55: "Atrás",
  title56: "Noticias",
  title57: "Actualizando el tiempo...",
  title58: "Tiempo actualizado",
  title59: "Ver Todo",
  title60: "Copyright © mobi321.com 2020 - 2026. Todos los derechos reservados",
  title61: "Ayer",
  title62: "Mañana",
  title63: "Ver la previsión del tiempo para 15 días",
  title64: "Los detalles de hoy",
  title65: "Rahu Kaal",
  title66: "Índices de estilo de vida",
  title67: "Índices de estilo de vida",
  title68: "未来7天Rahu Kala时间表",
  title69: "至",
  title70: "至",
  title71: "空气质量指数",

  title102: "Díficil de secar",
  title103: "Secado lento",
  title104: "Buen secado",
  title105: "Secado rápido",
  title106: "Secado muy rápido",

  title107: "No recomendable",
  title108: "Condiciones aceptables",
  title109: "Ideal para actividades acuáticas",
  title110: "Muy recomendable",
  title111: "Perfectas condiciones",

  title112: "Promueve la Salud",
  title113: "Condiciones normales",
  title114: "Riesgo ligeramente elevado",
  title115: "Riesgo alto",
  title116: "Riesgo muy alto",

  title117: "No apto",
  title118: "Algo apto",
  title119: "Ideal para exteriores",
  title120: "Muy apto",
  title121: "Excelentes condiciones",

  title122: "Condiciones de piel muy seca",
  title123: "Piel probablemente seca",
  title124: "Piel ligeramente seca",
  title125: "Piel poco probable seca",
  title126: "Piel muy poco probable seca",

  title127: "No recomendable",
  title128: "Aceptable",
  title129: "Buen día",
  title130: "Muy buenas condiciones",
  title131: "Condiciones ideales",
};
